import { TBillingRateType } from '../types/TRatesState';

const billingRateTypes: readonly TBillingRateType[] = ['FLAT_FEE', 'PER_HOUR', 'TIER_RATE', 'DISALLOWED'];

export const parseBillingRateType = (value: string): TBillingRateType | undefined =>
  billingRateTypes.find((rateType) => rateType === value);
